import React from 'react';
import { VscError } from 'react-icons/vsc';
import { ErrorMessage } from '../styles';

type FormErrorMessageProps = {
  isActive: boolean;
  isEn: boolean;
  errorMessage?: string | null;
};

export const FormErrorMessage: React.FC<FormErrorMessageProps> = ({ isActive, isEn }) => {
  const displayMessage = isEn
    ? 'An error ocurred when sending your answers. Try again later'
    : 'Ocorreu um erro ao enviar as suas respostas. Tente novamente em alguns instantes';

  return (
    <ErrorMessage className={isActive ? 'active' : ''}>
      <VscError size={22} />
      {displayMessage}
    </ErrorMessage>
  );
};
